export const INDEX_PAGE = "/"
export const WITHOUT_PERMISSION_PAGE = "/solicitar-acesso"
export const RECOVER_PASSWORD_PAGE = "/recuperar-senha"
export const REGISTER_PASSWORD_PAGE = "/register-password"
export const HOME_PAGE = "/home"
export const CLIENT_PAGE = "/clientes"
export const USER_PAGE = "/usuarios"
export const LOGOUT_PAGE = "/logout"
export const PROFILE_PAGE = "/perfil"
export const PRODUCT_PAGE = "/produtos"
export const FIXED_INCOME_CALCULATOR_PAGE = "/calculadora-renda-fixa"

export const PUBLIC_ROUTES = [
    INDEX_PAGE,
    RECOVER_PASSWORD_PAGE,
    REGISTER_PASSWORD_PAGE
]

export const CURVES_PAGE = "/curvas"
export const CURVES_TIR_PAGE = "/curvas-ettjc" //mudado 16/07
export const CURVES_SPREAD_PAGE = "/curvas-spread"
export const CURVES_SETORIAL_PAGE = "/curvas-setoriais"
export const CURVES_SUBSETORIAL_PAGE = "/curvas-subsetoriais"
export const CURVES_DTS_PAGE = "/curvas-dts"

export const PRICES_PAGE = "/precos"
export const CUSTOMERS_PRICE_LOG_PAGE = "/precos-log"
export const PRICES_UPDATE_SPREADS = "/atualizacao-spreads"
export const MEMORIA_DE_CALCULO = "/memoria-calculo"
export const MEMORIA_DE_CALCULO_V2_PAGE = "/v2/memoria-calculo"
export const PRICES_TABLE_BONDS_PAGE = "/precos-bonds"

export const IMPORT_PAGE = "/importacao"

export const CONCESSIONS_PAGE = "/concessoes"
export const WALLETS_PAGE = "/carteiras"
export const SIMULADOR_SUBORDINACAO_PAGE = "/simulador-subordinacao"
export const MARKET_RATES_PAGE = "/taxas-mercado"
export const PARAMETERS_PAGE = "/parametrosGR"
export const PARAMETERS_CALC_PAGE = "/parametros-calculo"
export const PARAMETERS_DATALAKE_PAGE = "/consulta-dados"
export const METHODOLOGY_PAGE = "/metodologia"
export const ROUTINES_PAGE = "/rotinas"
export const CONTINGENCIA_PAGE = "/contingencia"
export const TRATAMENTO_SPREADS_PAGE = "/tratamento-spreads"
export const INTEGRATION_WORKFLOW_PAGE = "/integracao-workflow"
export const INTEGRATION_PAGE = "/integracao"
export const INTEGRATION_DATA_PAGE = "/integracao-dados-externos"
export const REPORT_DATA_WORKFLOW_PAGE = "/report-data-workflow"
export const REPORT_DATA_ROUTINES_WORKFLOW_PAGE = "/report-data-workflow"
export const DAILY_ROUTINES_REPORT_PAGE = "/daily-routines-report"
export const ROUTINES_HOME_PAGE = "/rotinas-home"

export const DELETE_DATA_PAGE = "/exclusao-dados"
export const EMISSAO_PAGE = "/emissao"
export const EMISSAO_V2_PAGE = "/v2/emissao"
export const API_INTEGRATION_PAGE = "/api-integracao"
export const API_PUBLIC_PAGE = "/api-c2p"
export const EMPRESAS_PAGE = "/empresas"
export const EMPRESAS_V2_PAGE = "/v2/empresas"

export const ACCESS_PAGE = "/acessos"
export const SUPPORT_PAGE = "/suporte"

export const RATER_CALCULADORA_PAGE="/rater-calculadora"
export const RATER_HISTORICO_PAGE="/rater-historico"
export const RATER_MERTON_PAGE="/rater-merton"
export const RATER_RELATORIO_PAGE="/rater-relatorio"
export const RATER_SETORIAL_PAGE="/rater-setorial"
export const RATER_CONFIGURACOES_PAGE="/rater-configuracoes"

export const PROMPT_PAGE = "/prompt"
export const MOTOR_CADASTRO_PAGE = "/motor/cadastro-caracteristicas"
export const MOTOR_CADASTRO_MANUAL_PAGE = "/motor/cadastro-caracteristicas/manual"
export const STATUS_CADASTRO_PAGE = "/motor/status-cadastro"
export const MOTOR_EVENTOS_PAGE = "/motor/cadastro-eventos"
export const MOTOR_EVENTOS_CADASTRO_PAGE = "/motor/cadastro-eventos/cadastro"
export const MOTOR_EVENTOS_PARAMETROS = `${MOTOR_EVENTOS_PAGE}/parametros`
export const MOTOR_CADASTRO_LOTE_PAGE = "/motor/cadastro-lote"

// design system
export const DESIGN_SYSTEM_PAGE = "/design-system"
export const DESIGN_SYSTEM_BUTTON_PAGE = "/design-system/buttons"
export const DESIGN_SYSTEM_TABLE_PAGE = "/design-system/table"
export const DESIGN_SYSTEM_INPUT_PAGE = "/design-system/input"
export const DESIGN_SYSTEM_SIDEBAR_PAGE = "/design-system/side-bar"
export const DESIGN_SYSTEM_DUPLA_CONFIRMACAO_PAGE = "/design-system/dupla-confirmacao"
export const DESIGN_SYSTEM_MODAL_DUPLICAR_PAGE = "/design-system/modal-duplicar"
export const DESIGN_SYSTEM_FORM_SECTION_PAGE = "/design-system/form-sections"
export const DESIGN_SYSTEM_STATUS_BADGE_PAGE = "/design-system/status-badge"
export const DESIGN_SYSTEM_STATUS_ICON_BADGE_PAGE = "/design-system/status-icon-badge"
export const DESIGN_SYSTEM_SNACKBAR_PAGE = "/design-system/snack-bar"
export const DESIGN_SYSTEM_FIELD_RENDERER_PAGE = "/design-system/field-renderer"
export const DESIGN_SYSTEM_GRID_FORM_SHEET_PAGE = "/design-system/grid-form-sheet"
export const DESIGN_SYSTEM_TABS_PAGE = "/design-system/tabs"
export const DESIGN_SYSTEM_INFO_DATA_PANEL_PAGE = "/design-system/info-data-panel"
export const DESIGN_SYSTEM_INFO_ITEM_PAGE = "/design-system/info-item"
export const DESIGN_SYSTEM_SUMMARY_SECTION_PAGE = "/design-system/summary-section"

// treinamento
export const TREINAMENTO_MERCADO_PAGO_PAGE = "/treinamento/mercado-pago"
